import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Section, SectionHead, AdSlot } from "@/components/common";
import { ClaimCard } from "@/pages/Home";

export default function Claims() {
  const [claims, setClaims] = useState([]);
  useEffect(() => { api.get("/claims").then((r) => setClaims(r.data)); }, []);
  return (
    <Section className="py-12 sm:py-16">
      <SectionHead eyebrow="Claims vs. Evidence" title="What's claimed, what's shown, what's unknown"
        desc="We don't assume data centers are good or bad. Each claim is paired with cited evidence, a confidence level, and an honest note on what remains unverified." />
      <div className="grid md:grid-cols-2 gap-6">
        {claims.map((c) => <ClaimCard key={c.id} c={c} />)}
      </div>
      <div className="mt-8"><AdSlot testid="claims-ad-slot" /></div>
    </Section>
  );
}
